import "./AutoBerles.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
export default function AutoBerlesPage() {
  return <div>
      <Header />
      <Footer />
    </div>;
}